import React from 'react';
import { FaWhatsapp, FaInstagram } from 'react-icons/fa'; 
import { IoLogoWhatsapp } from "react-icons/io";
import { useNavigate } from 'react-router-dom'; // Importa o hook useNavigate
import { 
  ContainerHome, 
  Header, 
  Logo, 
  SocialIcons, 
  SocialIcon, 
  Content, 
  Text, 
  LoginButton, 
  LeftSide, 
  Overlay, 
  TextContainer, 
  ButtonsWrapper,
  Imgs 
} from '../styles';

const LandingPage = () => {
  const navigate = useNavigate(); // Inicializa o hook

  return (
    <ContainerHome>
      <Header>
        <Logo src={Imgs.logo} alt="Logo" />
        <ButtonsWrapper>
          <LeftSide>
            <LoginButton onClick={() => navigate('/login')}>Login</LoginButton>
            <LoginButton onClick={() => navigate('/register')}>Cadastre-se</LoginButton>
          </LeftSide>
          <SocialIcons>
            <SocialIcon href="https://wa.me/5521976247010" target="_blank">
              <FaWhatsapp />
            </SocialIcon>
            <SocialIcon href="https://instagram.com/bluehousetennis/" target="_blank">
              <FaInstagram />
            </SocialIcon>
          </SocialIcons>
        </ButtonsWrapper>
      </Header>
      <Content>
        <TextContainer>
          <Overlay /> 
          <Text style={{zIndex: "2", position: "relative"}}>🎾 Blue House Tennis</Text>
          <Text>⛰️ A quadra com a vista mais bela do Rio de Janeiro!</Text>
          <Text style={{display: "flex", alignItems: "center", gap: "7px"}}><IoLogoWhatsapp style={{color: "#18d018", fontSize: "20px"}}/> (21) 97624-7010</Text>
          <Text>📍 Rua Jagua, 40 - Botafogo, Rio de Janeiro</Text>
        </TextContainer>
      </Content>
    </ContainerHome>
  );
};

export default LandingPage;
